import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { logError, checkValidResponse } from '@cigna/chcp/shared/util';
import { CodeSetResponse } from './codeset.model';

@Injectable({ providedIn: 'root' })
export class CodesetService {
  public SERVICE_CONSUMER_CODE = '1000';
  public codeSetApi: string;
  public searchApi: string;

  constructor(
    private http: HttpClient,
    @Inject('secureApi') secureApi: string,
  ) {
    this.codeSetApi = `${secureApi}/claims/v1/ref-codes/PCS_0000_SUPLMTL_EXPLN_FOR_RMK_CD/values`;
    this.searchApi = `${secureApi}/search/v1`;
  }
  getCodeSet() {
    const params: HttpParams = new HttpParams()
      .set('consumerCode', this.SERVICE_CONSUMER_CODE)
      .set('limit', '100');
    return this.http
      .get(`${this.codeSetApi}`, {
        params,
      })
      .pipe(map(this.checkCodeSetResponse), catchError(logError));
  }
  private checkCodeSetResponse(response: CodeSetResponse) {
    if (response && response.metaData) {
      const meta = response.metaData;
      if (!meta.errors) {
        return response;
      }
      throw meta.errors;
    }
    throw new Error();
  }

  search(
    searchText: string,
    claimSystem: string,
    asOfDate: string,
    searchBy: 'code' | 'desc' | '' = '',
  ) {
    let params: HttpParams = new HttpParams()
      .set('consumerCode', this.SERVICE_CONSUMER_CODE)
      .set('search', searchText)
      .set('asof', asOfDate)
      .set('claimSystem', claimSystem);

    if (searchBy) {
      params = params.append('searchBy', searchBy);
    }

    return this.http
      .get(`${this.searchApi}/codes/procedures`, {
        params,
      })
      .pipe(
        map(checkValidResponse),
        map((res) => res.matches),
        catchError(logError),
      );
  }

  codeInfo(code: string, claimSystem: string, lob: string) {
    const params: HttpParams = new HttpParams()
      .set('consumerCode', this.SERVICE_CONSUMER_CODE)
      .set('procedureCode', code)
      .set('claimSystem', claimSystem)
      .set('lob', lob);

    return this.http
      .get(`${this.searchApi}/codes/procedure/${code}`, {
        params,
      })
      .pipe(
        map(checkValidResponse),
        map((res) => res.procedure),
        catchError(logError),
      );
  }
}
